import { SUPPLIER_BACKEND_API_ENDPOINTS } from "../config/apiConfig";
import { apiClient } from "./api-client.service";

import type {
  SupplierWalletTransactionFilter,
  SupplierWalletTransactionResponse,
} from "../types/supplier-wallet.types";

const endpoints = SUPPLIER_BACKEND_API_ENDPOINTS.supplierWallet;

export const supplierWalletService = {
  async transactions(filter: SupplierWalletTransactionFilter): Promise<SupplierWalletTransactionResponse> {
    try {
      const params = new URLSearchParams();
      Object.entries(filter).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.set(key, String(value));
        }
      });

      return await apiClient<SupplierWalletTransactionResponse>(endpoints.transactions(params.toString()), {
        method: "GET",
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return {
        success: false,
        statusCode: 500,
        message: error instanceof Error ? error.message : "Failed to load wallet transactions due to an unexpected error.",
        resData: null,
      };
    }
  },
};
